<mat-card class="query-card">
  <mat-card-content>
    @if (!hasSubmitted) {
    <form [formGroup]="queryForm" (ngSubmit)="submitQuery()" class="query-form">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Read-Only SQL Query</mat-label>
        <textarea
          matInput
          formControlName="query"
          rows="6"
          spellcheck="false"
          class="monospace"
        ></textarea>
        <!-- <mat-hint align="start">Read-only queries only.</mat-hint> -->
      </mat-form-field>

      <div class="actions">
        <button
          mat-stroked-button
          color="primary"
          type="submit"
          [disabled]="queryForm.invalid || isSubmitting"
        >
          <mat-icon>play_arrow</mat-icon>
          Submit
        </button>
      </div>
    </form>
    } @else if (querySubmission) {
    <div class="submission-details mat-elevation-z1">
      <table>
        <tr
          [class.highlight]="isPendingStatus(querySubmission.status) || isPartialStatus(querySubmission.status)"
          [class.status-error-row]="querySubmission.status === 'error'"
          [class.status-partial-row]="isPartialStatus(querySubmission.status)"
        >
          <td><strong>Status:</strong></td>
          <td
            [class.status-success-text]="querySubmission.status === 'success'"
            [class.status-partial-text]="isPartialStatus(querySubmission.status)"
          >
            {{ querySubmission.status }}
          </td>
        </tr>
        <tr>
          <td><strong>Job ID:</strong></td>
          <td>{{ querySubmission.job_id || 'Assigning…' }}</td>
        </tr>
        <tr>
          <td><strong>Query:</strong></td>
          <td>{{ querySubmission.query }}</td>
        </tr>
        <tr>
          <td><strong>Creation Time:</strong></td>
          <td>{{ formatCreationTime(querySubmission.creation_time) }}</td>
        </tr>
        @if (querySubmission.error_message) {
        <tr>
          <td><strong>Error Message:</strong></td>
          <td>{{ querySubmission.error_message }}</td>
        </tr>
        }
      </table>
      @if (querySubmission.status === 'error') {
      <div class="actions results-actions">
        <button mat-stroked-button type="button" (click)="clearResults()">Clear</button>
      </div>
      }
    </div>
    }
  </mat-card-content>
</mat-card>

@if (!hasSubmitted) {
<h3 class="example-title">Demo Queries</h3>
<p class="schema-note">
  For a complete list of the database schema, including tables and the columns within each table,
  see the
  <a
    href="https://cgi.minorplanetcenter.net/mpcops/documentation/replicated-tables-schema/"
    target="_blank"
    rel="noopener"
    >MPC's website</a
  >.
</p>
<div class="example-queries">
  @for (example of exampleQueries; track example.buttonLabel) {
  <button mat-stroked-button color="accent" type="button" (click)="applyExample(example.sql)">
    <div class="example-label">{{ example.buttonLabel }}</div>
    <div class="example-sql">{{ example.sql }}</div>
  </button>
  }
</div>
}
